import React, { useState } from "react";
import { toast } from "react-toastify";

const UserProfileModal = ({ token, userDetails, closeModal }) => {
  const [editedData, setEditedData] = useState({ ...userDetails });
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setEditedData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleImageChange = (event) => {
    const imageFile = event.target.files[0];
    setEditedData((prevData) => ({
      ...prevData,
      profileImage: imageFile,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const formData = new FormData();
    formData.append("name", editedData.name);
    formData.append("email", editedData.email);
    formData.append("about", editedData.about);
    formData.append("education", editedData.education);
    formData.append("school", editedData.school);
    formData.append("location", editedData.location);
    formData.append("profileImage", editedData.profileImage);

    try {
      const response = await fetch(
        `${baseUrl}/api/user/profile/${userDetails._id}`,
        {
          method: "PUT",
          body: formData,
          headers: {
            Authorization: ` ${token}`,
          },
        }
      );
      if (response.ok) {
        const data = await response.json();
        console.log(data.data);
        
        localStorage.setItem("USER_INFO", JSON.stringify(data.data));
        toast.success("Profile updated successfully", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        closeModal();
      } else if (response.status === 500) {
        toast.error("Internal server error. Please try again later.", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      } else {
        const data = await response.json();
        console.log(data.data);
        
        toast.error(data.error.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      }
    } catch (error) {
      console.error("An error occurred while updating profile data:", error);
      toast.error("An error occurred. Please try again.", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };

  return (
    <div className="fixed top-16 left-0 w-full h-full bg-black bg-opacity-50 px-5 py-[2%] md:flex justify-center">
      <div className="bg-white p-6 lg:w-1/3 rounded-md shadow-md overflow-y-auto h-fit lg:h-[90%] ">
        <h2 className="text-lg font-semibold mb-4">Edit Profile</h2>
        <form onSubmit={handleSubmit}>
          {/* Profile Image */}
          <div className="mb-4">
            <label className="block mb-1 font-medium">Profile Image</label>
            <input
              type="file"
              accept="image/*"
              name="profileImage"
              onChange={handleImageChange}
              className="w-full"
            />
          </div>
          {/* Name */}
          <div className="mb-4">
            <label className="block mb-1 font-medium">Name</label>
            <input
              type="text"
              name="name"
              value={editedData.name}
              onChange={handleInputChange}
              placeholder="Enter your name"
              className="w-full rounded-md border px-3 py-2"
            />
          </div>

          {/* Email */}
          <div className="mb-4">
            <label className="block mb-1 font-medium">Email</label>
            <input
              type="email"
              name="email"
              value={editedData.email}
              onChange={handleInputChange}
              placeholder="Enter your email"
              className="w-full rounded-md border px-3 py-2"
            />
          </div>

          {/* About */}
          <div className="mb-4">
            <label className="block mb-1 font-medium">About</label>
            <input
              name="about"
              value={editedData.about}
              onChange={handleInputChange}
              placeholder="Tell us something about yourself"
              className="w-full rounded-md border px-3 py-2"
            />
          </div>

          {/* Education */}
          <div className="mb-4">
            <label className="block mb-1 font-medium">Education</label>
            <input
              type="text"
              name="education"
              value={editedData.education}
              onChange={handleInputChange}
              placeholder="Enter your education details"
              className="w-full rounded-md border px-3 py-2"
            />
          </div>

          {/* School */}
          <div className="mb-4">
            <label className="block mb-1 font-medium">School</label>
            <input
              type="text"
              name="school"
              value={editedData.school}
              onChange={handleInputChange}
              placeholder="Enter your school details"
              className="w-full rounded-md border px-3 py-2"
            />
          </div>

          {/* Location */}
          <div className="mb-6">
            <label className="block mb-1 font-medium">Location</label>
            <input
              type="text"
              name="location"
              value={editedData.location}
              onChange={handleInputChange}
              placeholder="Enter your location"
              className="w-full rounded-md border px-3 py-2"
            />
          </div>

          <div className="flex justify-end">
            <button
              type="button"
              className="bg-gray-300 px-4 py-2 rounded-md mr-2"
              onClick={closeModal}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
              onClick={handleSubmit}
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UserProfileModal;
